import React, { useContext, useState } from "react";
import { Grid, Stack, Typography, Box, Paper, Divider } from "@mui/material";
import { UserDetailsContext } from "../Context/userDetailsContext";
import RequestServiceForm from "../Components/RequestServiceForm/index";
import { isMobile } from "react-device-detect";
import { useLocation } from "react-router";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const RequestService = () => {
  const { userDetails } = useContext(UserDetailsContext);
  const location = useLocation();
  const { state } = location;

  return (
    <Stack gap={3} sx={{ padding: 3 }}>
      <Stack
        direction={isMobile ? "column" : "row"}
        justifyContent={"space-between"}
        gap={2}
      >
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "12px",
            width: isMobile ? "100%" : 300,
            border: "2px solid",
            borderColor: "primary.main",
            boxShadow: "0px 4px 12px rgba(25, 118, 210, 0.15)",
          }}
        >
          <PersonIcon sx={{ mr: 1, color: "primary.main" }} />
          <Typography variant="h6" color="primary.main">بيانات مقدم الطلب</Typography>
        </Paper>
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "12px",
            width: isMobile ? "100%" : 300,
            border: "2px solid",
            borderColor: "success.main",
            boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.15)",
          }}
        >
          <AttachMoneyIcon sx={{ mr: 1, color: "success.main" }} />
          <Typography variant="h6" color="success.main">{`${state?.applicationFee} ${state?.currency?.[0]?.name}`}</Typography>
        </Paper>
      </Stack>

      <Paper
        elevation={2}
        sx={{ 
          backgroundColor: "#fff", 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
        <Grid item sm={6} lg={3} md={4} xs={12}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <PersonIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Stack direction="row" gap={1} flexWrap="wrap">
              <Typography sx={{ fontWeight: "bold", color: "text.primary" }}>
                اسم مقدم الطلب:
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {userDetails?.citizen?.fullName}
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item sm={6} lg={3} md={4} xs={12}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <DescriptionIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Stack direction="row" gap={1} flexWrap="wrap">
              <Typography sx={{ fontWeight: "bold", color: "text.primary" }}>
                نوع الوثيقة:
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {userDetails?.citizen?.documentType.textA}
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item sm={6} lg={3} md={4} xs={12}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <BadgeIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Stack direction="row" gap={1} flexWrap="wrap">
              <Typography sx={{ fontWeight: "bold", color: "text.primary" }}>
                رقم الوثيقة:
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {userDetails?.citizen?.documentNumber}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid item sm={6} lg={3} md={4} xs={12}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <PhoneIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Stack direction="row" gap={1} flexWrap="wrap">
              <Typography sx={{ fontWeight: "bold", color: "text.primary" }}>
                رقم الموبايل:
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {userDetails?.citizen?.phone1}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        <Grid item md={6} xs={12}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <EmailIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Stack direction="row" gap={1} flexWrap="wrap" sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: "bold", color: "text.primary" }}>
                البريد الإلكتروني:
              </Typography>
              <Typography
                title={userDetails?.citizen?.email}
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: "text.secondary",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                {userDetails?.citizen?.email}
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item md={6} xs={12}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <HomeIcon sx={{ color: "primary.main", fontSize: 22 }} />
            <Stack direction="row" gap={1} flexWrap="wrap">
              <Typography sx={{ fontWeight: "bold", color: "text.primary" }}>
                العنوان:
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {userDetails?.citizen?.address}
              </Typography>
            </Stack>
          </Box>
        </Grid>
        </Grid>
      </Paper>
      <RequestServiceForm />
    </Stack>
  );
};
export default RequestService;
